/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Same_None_HintInputs */

const en_us2_profile_editors_same_none_hint = /** @type {(inputs: Profile_Editors_Same_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You say how many days and train when you can.`)
};

const pt_br2_profile_editors_same_none_hint = /** @type {(inputs: Profile_Editors_Same_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você diz quantos dias e treina quando der.`)
};

const es_419_profile_editors_same_none_hint = /** @type {(inputs: Profile_Editors_Same_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dices cuántos días y entrenas cuando puedes.`)
};

const pt_pt2_profile_editors_same_none_hint = /** @type {(inputs: Profile_Editors_Same_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dizes quantos dias e treinas quando puderes.`)
};

const fr_fr2_profile_editors_same_none_hint = /** @type {(inputs: Profile_Editors_Same_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu indiques combien de jours et tu t'entraînes quand tu peux.`)
};

const de_de2_profile_editors_same_none_hint = /** @type {(inputs: Profile_Editors_Same_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du sagst, wie viele Tage, und trainierst, wann du kannst.`)
};

const it_it2_profile_editors_same_none_hint = /** @type {(inputs: Profile_Editors_Same_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dici quanti giorni e ti alleni quando puoi.`)
};

/**
* | output |
* | --- |
* | "You say how many days and train when you can." |
*
* @param {Profile_Editors_Same_None_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_same_none_hint = /** @type {((inputs?: Profile_Editors_Same_None_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Same_None_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_same_none_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_same_none_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_same_none_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_same_none_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_same_none_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_same_none_hint(inputs)
	return en_us2_profile_editors_same_none_hint(inputs)
});
export { profile_editors_same_none_hint as "profile-editors.same_none_hint" }